/* ============================================================
   PDP iyileştirmeleri (UI/UX denetimi, Faz 2)
   ------------------------------------------------------------
   main-product.js'e dokunmadan, onun kurduğu durumu OKUYAN ek katman:

   - Beden uyarısı: beden seçmeden butona basınca buton metni "BEDEN
     SEÇİN"e dönüyordu ama ekranda açıklama yoktu. Uyarı + bedenlere kaydır.
   - Beden tablosu linki: tablo (Kiwi) sayfanın dibindeki akordeonda.
     Link tablo dolunca görünür, tıklayınca akordeonu açıp oraya kaydırır.
   - Renk görselleri: üzerine gelinen rengin adı etikette görünür.
   - Mobil sabit alt çubuk: asıl buton ekrandan çıkınca görünür, tıklamayı
     o anki asıl eyleme devreder (kendi sepete-ekle mantığı yok, böylece
     sepet limiti / paket builder / tükenen beden akışları tek yerde kalır).
   ============================================================ */
(function () {
  'use strict';

  function formatTl(cents) {
    return Math.round((Number(cents) || 0) / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' TL';
  }

  function isVisible(el) {
    return !!(el && el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden');
  }

  function headerOffset() {
    var header = document.getElementById('shopify-section-header');
    var bottom = header ? header.getBoundingClientRect().bottom : 0;
    return Math.max(0, bottom) + 16;
  }

  function scrollIntoViewSoft(el, block) {
    if (!el) return;
    var rect = el.getBoundingClientRect();
    var top;
    if (block === 'center') {
      top = window.pageYOffset + rect.top - (window.innerHeight - rect.height) / 2;
    } else {
      top = window.pageYOffset + rect.top - headerOffset();
    }
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  var sizeArea = null;
  var warning = null;

  function hasSizeChoice() {
    return document.querySelectorAll('#size-selection-area a.size-options').length > 1;
  }

  function selectedSize() {
    return document.querySelector('#size-selection-area a.size-options.selected-option');
  }

  /* ----- beden uyarısı ----- */
  function showSizeWarning() {
    if (!sizeArea) return;
    if (warning) warning.hidden = false;
    sizeArea.classList.remove('is-attention');
    // animasyonu yeniden tetiklemek için reflow
    void sizeArea.offsetWidth;
    sizeArea.classList.add('is-attention');
    var rect = sizeArea.getBoundingClientRect();
    var fullyVisible = rect.top >= headerOffset() && rect.bottom <= window.innerHeight - 90;
    if (!fullyVisible) scrollIntoViewSoft(sizeArea, 'center');
  }

  function hideSizeWarning() {
    if (warning) warning.hidden = true;
    if (sizeArea) sizeArea.classList.remove('is-attention');
  }

  function initSizeWarning() {
    sizeArea = document.getElementById('size-selection-area');
    warning = document.querySelector('[data-fos-size-warning]');
    var openBtn = document.getElementById('open-info-btn');
    if (!sizeArea) return;

    if (openBtn) {
      openBtn.addEventListener('click', function (e) {
        // theme.liquid sayfa açılınca bu butona programatik tıklıyor (masaüstü
        // bilgi panelini açmak için); uyarı yalnız gerçek tıklamada çıksın.
        if (!e.isTrusted) return;
        if (hasSizeChoice() && !selectedSize()) showSizeWarning();
      });
    }
    sizeArea.addEventListener('click', function (e) {
      if (e.target.closest('a.size-options')) hideSizeWarning();
    });

    // Beden <a>'ları radio gibi davranır: seçili olan aria-checked, klavyeyle
    // Enter/Space seçer (main-product.js tıklamayı dinliyor).
    function syncChecked() {
      sizeArea.querySelectorAll('a.size-options').forEach(function (a) {
        a.setAttribute('aria-checked', a.classList.contains('selected-option') ? 'true' : 'false');
      });
    }
    new MutationObserver(syncChecked).observe(sizeArea, { attributes: true, subtree: true, attributeFilter: ['class'] });
    syncChecked();
    sizeArea.addEventListener('keydown', function (e) {
      var option = e.target.closest('a.size-options');
      if (!option || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault();
      option.click();
    });
  }

  /* ----- beden tablosu linki ----- */
  function sizeChartPanel() {
    var panels = document.querySelectorAll('.size-panel');
    for (var i = 0; i < panels.length; i++) {
      var p = panels[i];
      var accord = p.closest('.product-accord');
      if (p.innerHTML.trim() !== '' && accord && isVisible(accord)) return p;
    }
    return null;
  }

  function initSizeGuide() {
    var link = document.querySelector('[data-fos-size-guide]');
    if (!link) return;

    function sync() {
      link.hidden = !sizeChartPanel();
    }

    var obs = new MutationObserver(sync);
    document.querySelectorAll('.size-panel').forEach(function (p) {
      obs.observe(p, { childList: true });
    });
    window.addEventListener('resize', sync, { passive: true });
    sync();

    link.addEventListener('click', function () {
      var panel = sizeChartPanel();
      if (!panel) return;
      var toggle = panel.previousElementSibling;
      if (toggle && toggle.classList.contains('accordion') && !toggle.classList.contains('active')) {
        toggle.click();
      }
      scrollIntoViewSoft(toggle || panel, 'start');
    });
  }

  /* ----- renk görselleri ----- */
  function initColours() {
    var root = document.querySelector('[data-fos-colours]');
    if (!root) return;
    var label = root.querySelector('[data-fos-colour-name]');
    if (!label) return;
    var current = label.getAttribute('data-current') || label.textContent;

    function show(e) {
      var item = e.target.closest('[data-colour-name]');
      if (item) label.textContent = item.getAttribute('data-colour-name');
    }
    function reset(e) {
      if (!e.relatedTarget || !root.contains(e.relatedTarget)) label.textContent = current;
    }
    root.addEventListener('mouseover', show);
    root.addEventListener('focusin', show);
    root.addEventListener('mouseout', reset);
    root.addEventListener('focusout', reset);
  }

  /* ----- mobil sabit alt çubuk ----- */
  function initStickyBar() {
    var bar = document.querySelector('[data-fos-sticky-atc]');
    var buttonArea = document.querySelector('#product-slack-windows-show .button-area');
    var addBtn = document.getElementById('visual-add-to-cart-btn');
    if (!bar || !buttonArea || !addBtn) return;

    var sizeEl = bar.querySelector('[data-fos-sticky-size]');
    var priceEl = bar.querySelector('[data-fos-sticky-price]');
    var btn = bar.querySelector('[data-fos-sticky-btn]');
    var oneSize = bar.getAttribute('data-one-size') === 'true';
    var labels = {
      chooseSize: bar.getAttribute('data-label-choose-size') || '',
      size: bar.getAttribute('data-label-size') || '__SIZE__',
      notify: bar.getAttribute('data-label-notify') || '',
      add: bar.getAttribute('data-label-add') || ''
    };
    var mainInView = true;
    var mode = 'add';

    function currentPrice() {
      var root = document.querySelector('.name-price .price .price') || document.querySelector('.fos-product-price .price');
      if (!root) return '';
      var el = root.classList.contains('price--on-sale')
        ? root.querySelector('.price__sale .price-item--sale')
        : root.querySelector('.price__regular .price-item--regular');
      return el ? el.textContent.trim() : '';
    }

    function sync() {
      var packageMode = addBtn.dataset.fosPackageMode === 'true';
      var bisActive = buttonArea.classList.contains('is-bis-active');
      var luckySoldOut = buttonArea.classList.contains('is-lucky-sold-out');
      var picked = selectedSize();

      var sizeText = '';
      if (!oneSize && !packageMode) {
        sizeText = picked
          ? labels.size.replace('__SIZE__', (picked.getAttribute('data-title') || picked.textContent).trim())
          : labels.chooseSize;
      }
      sizeEl.textContent = sizeText;
      sizeEl.hidden = !sizeText;

      var pack = window.fosPack;
      priceEl.textContent = packageMode && pack && pack.totalCents ? formatTl(pack.totalCents) : currentPrice();

      var label = labels.add;
      var disabled = false;
      if (packageMode) {
        mode = 'package';
        label = addBtn.textContent.trim() || labels.add;
      } else if (bisActive) {
        mode = 'notify';
        label = labels.notify;
      } else if (luckySoldOut) {
        mode = 'none';
        label = addBtn.textContent.trim();
        disabled = true;
      } else if (!oneSize && !picked) {
        mode = 'size';
      } else if (addBtn.disabled) {
        mode = 'none';
        disabled = true;
      } else {
        mode = 'add';
      }
      btn.textContent = label;
      btn.disabled = disabled;
    }

    function setVisible() {
      var show = !mainInView;
      bar.hidden = !show;
      document.documentElement.classList.toggle('has-fos-sticky-atc', show);
    }

    btn.addEventListener('click', function () {
      if (mode === 'package') {
        addBtn.click();
      } else if (mode === 'notify') {
        var bis = document.getElementById('fos-bis');
        scrollIntoViewSoft(bis || buttonArea, 'center');
        var email = bis && bis.querySelector('.fos-bis__email');
        if (email) setTimeout(function () { email.focus({ preventScroll: true }); }, 400);
      } else if (mode === 'size') {
        showSizeWarning();
      } else if (mode === 'add') {
        addBtn.click();
      }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        mainInView = entries[0].isIntersecting;
        setVisible();
      }).observe(buttonArea);
    }

    new MutationObserver(sync).observe(buttonArea, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
    var sizes = document.getElementById('size-selection-area');
    if (sizes) {
      new MutationObserver(sync).observe(sizes, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('fos-opt__radio')) {
        window.requestAnimationFrame(sync);
      }
    });
    ['fos:pdp-variant-changed', 'cart:itemAdded', 'fos:pdp-package-builder-closed', 'fos:pdp-package-builder-completed'].forEach(function (ev) {
      document.addEventListener(ev, function () { window.requestAnimationFrame(sync); });
    });

    sync();
  }

  function init() {
    initSizeWarning();
    initSizeGuide();
    initColours();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
